'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTtsUrl, getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import nonMerchandiseIdProductPropInterface from 'pricing-pages-unified-ui/utils/nonMerchandiseIdProductPropInterface';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import partial from 'transmute/partial';
import classNames from 'pricing-pages-unified-ui/utils/classNames';
import { hubsSignupCTASelector, hubsSignupUrlSelector } from '../../selectors/TrackingSelectors';
import { getSavedQueryParamString } from 'pricing-pages-lib/utils/queryParamUtils';
import { productForSkuIdSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';

const TalkToSalesButton = ({
  sourceId,
  skuId,
  use,
  className,
  nonMerchandiseIdProduct,
  style,
  block,
  hubsSignupProductOverride,
  size
}) => {
  const hubsSignupCta = useSelector(state => hubsSignupCTASelector(state, {
    skuId,
    ctaType: 'tts',
    sourceId,
    nonMerchandiseIdProduct: hubsSignupProductOverride || nonMerchandiseIdProduct
  }));
  const gaClassName = getGAClassName(hubsSignupCta);
  const hubsSignupUrl = useSelector(state => hubsSignupUrlSelector(state, {
    skuId,
    nonMerchandiseIdProduct: hubsSignupProductOverride || nonMerchandiseIdProduct
  }));
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const apiName = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }).apiName);
  const hubsParamString = getSavedQueryParamString() && `&${getSavedQueryParamString()}`;
  const HREF = `${getTtsUrl()}?hubs_signup-url=${hubsSignupUrl}&hubs_signup-cta=${hubsSignupCta}${hubsParamString}`;

  const onClick = () => {
    getUsageTracker().track('talkToSales', {
      sourceId,
      skuId,
      productName: apiName,
      nonMerchandiseIdProduct,
      hubsSignupCta,
      hubsSignupUrl,
      upgradeProduct
    });
  };

  return /*#__PURE__*/_jsx(UIButton, {
    use: use,
    href: HREF,
    className: classNames(gaClassName, className),
    target: "_blank",
    "data-selenium-id": "talk-to-sales-button",
    onClick: partial(onClick),
    style: style,
    block: block,
    size: size,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.talkToSales",
      className: gaClassName
    })
  });
};

TalkToSalesButton.propTypes = Object.assign({
  sourceId: PropTypes.string.isRequired,
  skuId: PropTypes.number,
  use: PropTypes.string.isRequired,
  className: PropTypes.string,
  hubsSignupProductOverride: PropTypes.string
}, nonMerchandiseIdProductPropInterface);
TalkToSalesButton.defaultProps = {
  use: 'primary'
};
export default TalkToSalesButton;